import { render, staticRenderFns } from "./fenxiang918.vue?vue&type=template&id=2b2bc94a&scoped=true"
import script from "./fenxiang918.vue?vue&type=script&lang=js"
export * from "./fenxiang918.vue?vue&type=script&lang=js"
import style0 from "./fenxiang918.vue?vue&type=style&index=0&id=2b2bc94a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2bc94a",
  null
  
)

export default component.exports